import { render, staticRenderFns } from "./warehouseconsumable.vue?vue&type=template&id=31059834&scoped=true&"
import script from "./warehouseconsumable.vue?vue&type=script&lang=js&"
export * from "./warehouseconsumable.vue?vue&type=script&lang=js&"
import style0 from "./warehouseconsumable.vue?vue&type=style&index=0&id=31059834&scoped=true&lang=css&"
import style1 from "./warehouseconsumable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31059834",
  null
  
)

export default component.exports